import { vars } from '@repo/config';
import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IBackfillVaultPathResponse } from './backfill-vault-path-response';
import { backfillVaultPathResponseSchema } from './backfill-vault-path-response';

export async function backfillVaultPathApi(): Promise<
  IValidatedResponse<IBackfillVaultPathResponse>
> {
  return postRequest<IBackfillVaultPathResponse>({
    path: '/sys/subtitles/backfill-vault-path',
    body: { vaultUrl: vars.url.vaultUrl },
    schema: backfillVaultPathResponseSchema,
  });
}
